import { CalendarSpec } from 'moment/moment';

const TIME_FORMAT = '[at] h:mm a';
const DATE_FORMAT = 'MMM D';
const DATETIME_FORMAT = `MMM D ${TIME_FORMAT}`;
const ASAP_TELEMED_TEXT = 'next available provider';

export const bookAheadTimeFormats: CalendarSpec = {
  lastWeek: `ddd, ${DATETIME_FORMAT}`,
  sameDay: `[Today] ${TIME_FORMAT}`,
  lastDay: `[Yesterday] ${TIME_FORMAT}`,
  nextDay: `[Tomorrow] ${TIME_FORMAT}`,
  nextWeek: `ddd, ${DATETIME_FORMAT}`,
  sameElse: `ddd, ${DATETIME_FORMAT}`,
};

export const walkInTimeFormats: CalendarSpec = {
  lastWeek: `[Checked in] ddd, ${DATETIME_FORMAT}`,
  sameDay: `[Checked in today] ${TIME_FORMAT}`,
  lastDay: `[Checked in yesterday] ${TIME_FORMAT}`,
  nextDay: `[Checked in tomorrow] ${TIME_FORMAT}`,
  nextWeek: `[Checked in] ddd, ${DATETIME_FORMAT}`,
  sameElse: `[Checked in] ddd, ${DATETIME_FORMAT}`,
};

export const timeFormatAsapTelemed: CalendarSpec = {
  lastWeek: `[Last] ddd, [${ASAP_TELEMED_TEXT}]`,
  sameDay: `[Today], [${ASAP_TELEMED_TEXT}]`,
  lastDay: `[Yesterday], [${ASAP_TELEMED_TEXT}]`,
  nextDay: `[Tomorrow], [${ASAP_TELEMED_TEXT}]`,
  nextWeek: `[Next] ddd, [${ASAP_TELEMED_TEXT}]`,
  sameElse: `ddd, [${ASAP_TELEMED_TEXT}]`,
};

//note, for online waitlist, future dates should not be possible, but we are handling it just in case.
export const timeFormatOnlineWaitlist: CalendarSpec = {
  lastWeek: `[Last] ddd, ${DATE_FORMAT}`,
  sameDay: `[Today], ${DATE_FORMAT}`,
  lastDay: `[Yesterday], ${DATE_FORMAT}`,
  nextDay: `[Tomorrow], ${DATE_FORMAT}`,
  nextWeek: `[Next] ddd, ${DATE_FORMAT}`,
  sameElse: `ddd, ${DATE_FORMAT}`,
};
